import React, { useEffect } from "react";
import {
  Flex,
  Heading,
  Text,
  Stack,
  IconButton,
  Avatar,
  Box,
  Icon,
} from "@chakra-ui/react"; // Add these imports
import { FaArrowLeftLong, FaXmark } from "react-icons/fa6";
import { textSecondary, white, primaryAlt } from "../../../../../utils/colors";
import ToastComponent from "../../../../../components/partials/ToastComponent";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
// import SidePanel from "../../../../../components/sidepanel/SidePanel";
// import EditPatient from "../../sidepanels/EditPatientNew";
import useIsMobile from "../../../../../hooks/useIsMobile";
import StatusButtonNew from "../../../../../components/buttons/StatusButtonNew";
import { useNavigate } from "react-router-dom";
import useThemeColors from "../../../../../hooks/useThemeColors";
import MoreButtonLite from "../../../../../components/buttons/MoreButtonLite";
import { DELETE_PATIENT_RESET } from "../../../../../constants/patientConstants";

const PatientHeader = ({
  slug,
  patient,
  isDoctor,
  openEdit,
  setShowDeleteConfirmation,
  setPatientName,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toastComponent = ToastComponent();
  const dispatch = useDispatch();

  const { whiteMode, backgroundLightMode, textPrimaryMode, newBorderMode } =
    useThemeColors();

  const navigateBackHandler = () => {
    // window.history.back();
    navigate(`/${slug}/patients`);
  };

  // REDUX
  const deletePatient = useSelector((state) => state.deletePatient);
  const { error: errorDelete, success: successDelete } = deletePatient;

  useEffect(() => {
    if (successDelete) {
      navigate(`/${slug}/patients`);
    } else if (errorDelete) {
      toastComponent.showToast(t("toasts.patientDeleteError"), "error", 3000);
    }

    dispatch({ type: DELETE_PATIENT_RESET }); // Reset the delete state after handling success or error
  }, [successDelete, errorDelete]);

  const isMobile = useIsMobile();

  // console.log("patient", patient);
  // console.log("tenant", tenant);

  return (
    <>
      <Flex
        align="center"
        justify="space-between"
        p={["1.75rem 1.5rem", "1.75rem 2rem"]}
        borderBottom={`1px solid ${newBorderMode}`}
        position="relative"
        width="100%"
        // bg={white}
        // zIndex="1000"
      >
        <Flex align="center" w="100%">
          {!isMobile && (
            <IconButton
              bg={backgroundLightMode}
              border={`1px solid ${backgroundLightMode}`}
              color={textSecondary}
              icon={<FaArrowLeftLong />}
              borderRadius="10.75rem"
              fontSize="0.875rem"
              onClick={navigateBackHandler}
              _hover={{ bg: primaryAlt, color: white, border: primaryAlt }}
            />
          )}

          <Flex
            align="center"
            m={["0 0 0 0rem", "0 0 0 1rem", "0 0 0 1rem"]}
            w="100%"
          >
            <Avatar
              h={["2.5rem", "2.75rem"]}
              w={["2.5rem", "2.75rem"]}
              bg={textPrimaryMode}
              color={whiteMode}
              src={patient.image}
              // borderRadius="0.75rem"
              name={`${patient.lastName} + ${patient.firstName}`}
              display={["none", "flex"]}
            />

            {!isMobile ? (
              <Stack gap={1.5}>
                <Heading
                  ml={2}
                  color={textPrimaryMode}
                  fontSize="1.125rem"
                  fontWeight="600"
                  lineHeight="1"
                >
                  {patient.lastName} {patient.firstName}
                </Heading>
                <Flex align="center">
                  <Text
                    ml={2}
                    color={textSecondary}
                    fontSize="sm"
                    lineHeight="1"
                  >
                    {t("patient.headerCardNumber")}:
                    <Text as="span" fontWeight="600" ml={1} lineHeight="1">
                      {patient &&
                        patient.patientID &&
                        patient.patientID.length > 0 &&
                        patient.patientID}
                    </Text>
                  </Text>
                </Flex>
              </Stack>
            ) : (
              <Stack gap={0} w="100%">
                <Text
                  fontSize="md"
                  fontWeight="600"
                  color={textPrimaryMode}
                  maxW="90%"
                  isTruncated
                >
                  {t("patient.patient")}{" "}
                  <Text
                    as="span"
                    fontWeight="600"
                    fontSize="md"
                    color={textSecondary}
                    ml={0.5}
                  >
                    {patient &&
                      patient.patientID &&
                      patient.patientID.length > 0 &&
                      patient.patientID}
                  </Text>
                </Text>
                {/* <Text fontWeight="600" fontSize="md" color={textPrimaryMode}>
                  {patient.lastName} {patient.firstName}
                </Text> */}
                {/* <Box m="0.5rem 0 0">
                    
                <StatusButtonNew
                  isUnclickable
                  currentStatus={patient.status}
                  options="patient"
                  size={["sm", "md"]}
                  p={["0 1rem", "0 2rem"]}
                  fontSize={["0.75rem", "0.875rem"]}
                />
                </Box> */}
              </Stack>
            )}
          </Flex>
        </Flex>

        <Flex align="center">
          {/* <StatusButtonNew
            isUnclickable
            currentStatus={patient.status}
            options="patient"
            size={["sm", "md"]}
            p={["0 1rem", "0 2rem"]}
            fontSize={["0.75rem", "0.875rem"]}
          /> */}

          <Box display={["none", "block"]}>
            <MoreButtonLite
              id={patient._id}
              deleteHandler={true}
              editHandler={() => {
                openEdit(); // Open edit side panel
              }}
              setShowDeleteConfirmation={() => {
                setShowDeleteConfirmation(true); // Open confirmation modal
                setPatientName(`${patient.lastName} ${patient.firstName}`);
              }}
              // editHandler={openEdit}
              editLabel={t("patient.editPatient")}
              editButtonDisabled={isDoctor}
            />
          </Box>

          {isMobile && (
            <IconButton
              position="relative"
              // top="1.5rem"
              // right="1.5rem"
              size="sm"
              bg={backgroundLightMode}
              color={textSecondary}
              onClick={navigateBackHandler}
              borderRadius="10rem"
              ml="0.5rem"
              _hover={{ bg: primaryAlt, color: white }}
            >
              <Icon as={FaXmark} />
            </IconButton>
          )}

          {/* {isMobile && (
            <IconButton
              bg="none"
              border={`1px solid ${newBorder}`}
              color={textSecondary}
              onClick={close}
              icon={<FaXmark />}
              borderRadius="0.75rem"
              fontSize="0.75rem"
              ml={2}
            />
          )} */}
        </Flex>
      </Flex>
    </>
  );
};

export default PatientHeader;
